export const onPropsChangeHandler = component => {
  return ({ searchFilter, country }) => {
    const { searchQuery } = component.props;

    if (!searchQuery || searchQuery.length < 1) {
      return new Promise(resolve => resolve);
    }
    const filterType = component.getFilterType(searchFilter);

    if (searchFilter !== component.props.searchFilter) {
      window.scrollTo(0, 0);
    }

    return new Promise(resolve => {
      component.setState(
        {
          limit: filterType ? 20 : 3,
          offset: 0,
          result: {},
        },
        resolve,
      );
    }).then(() => component.search(country));
  };
};
